import { IWhistleBlowEdit, WhistleBlowEdit } from "./whistleBlowEdit";

export interface IWhistleBlowEditSaveSuccess extends IWhistleBlowEdit {
    id: string;
    rowId: string;
    message: string;
}

export class WhistleBlowEditSaveSuccess extends WhistleBlowEdit implements IWhistleBlowEditSaveSuccess {
    id: string;
    rowId: string;
    message: string;

    constructor();
    constructor(obj: IWhistleBlowEditSaveSuccess);
    constructor(obj?: any) {
        super(obj);
        this.id = obj && obj.id || "";
        this.rowId = obj && obj.rowId || "";
        this.message = obj && obj.message || "";
    }
}